
import { Vue, Component } from 'vue-property-decorator'
import Building from '@/types/building'
import Uploader from '@/components/media/Uploader.vue'
import Filelist from '@/components/media/Filelist.vue'
import AfasField from '@/components/afas/AfasField.vue'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { AfasField, Filelist, Uploader }
})

export default class BuildingShowDetailsTab extends Vue {
  settings = {
    routeNames: { list: 'buildings', show: 'buildingShow', edit: 'buildingEdit' },
    routeParamKey: 'buildingId',
    functionNames: { setCurrent: 'setCurrentBuilding', save: 'saveBuilding' },
    getterNames: { current: 'currentBuilding', loading: 'loadingBuilding', errors: 'projectErrors' }
  }

  get currentItem () : Building {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get isAfasBuilding () : boolean {
    return this.currentItem.in_afas
  }

  get productType () : string {
    switch (this.currentItem.product_type) {
      case 1:
        return 'Grondgebonden woning'
      case 2:
        return 'Appartement'
      case 3:
        return 'Garage'
      case 4:
        return 'VvE'
      default:
        return 'Overig'
    }
  }

  get objectType () : string {
    switch (this.currentItem.object_type) {
      case 1:
        return 'Koopwoning'
      case 2:
        return 'Huurwoning Tuvast'
      case 3:
        return 'Huurwoning Extern'
      default:
        return '-'
    }
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
